import PopularStocks from './PopularStocks';

export default PopularStocks;
